import React from "react";
import { Formik, Form as Formular, Field } from "formik";
import axios from "axios";
import {Input} from "../../components/form/Input";
import {utils} from "../../library/Utils";

export const Form = ({method, data, setHandleSubmit, loading, history, intl}) => {
    if(!data)
        data = {
            title: "",
            startDate: "",
            endDate: "",
            message: "",
        };

    const save = (values, setErrors) => {
        loading(true);

        let url = "";

        if(data.id)
            url = "api/flashMessages/" + data.id;
        else
            url = "api/flashMessages";

        axios({method: "POST", url: url, data: utils.objectToFormData(values, method)}).then(response => {
            loading(false);

            history.push('/flashMessages');
        }).catch(error => {
            if(error.response)
                setErrors(error.response.data.errors);

            loading(false);
        });
    };

    return (
        <Formik
            enableReinitialize={true}
            initialValues={data}
            onSubmit={(values, { setErrors }) => {
                save(values, setErrors);
            }}
        >
            {props => {
                setHandleSubmit(props.handleSubmit);

                return (
                    <Formular className="form form-label-right">
                        <div className="row">
                            <div className="col-md-8 offset-md-2 col-12 offset-0 mb-20">
                                <Field
                                    name="title"
                                    component={Input}
                                    withFeedbackLabel={true}
                                    label={intl.formatMessage({id: "Titre"})}
                                />
                                <Field
                                    name="startDate"
                                    component={Input}
                                    type="date"
                                    withFeedbackLabel={true}
                                    label={intl.formatMessage({id: "Date de début"})}
                                    {...props}
                                />
                                <Field
                                    name="endDate"
                                    component={Input}
                                    type="date"
                                    withFeedbackLabel={true}
                                    label={intl.formatMessage({id: "Date de fin"})}
                                    {...props}
                                />
                                <Field
                                    name="message"
                                    component={Input}
                                    withFeedbackLabel={true}
                                    label={intl.formatMessage({id: "Message"})}
                                    multiline
                                    rows="4"
                                />
                            </div>
                        </div>
                    </Formular>
                )}
            }
        </Formik>
    );
}
